'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { getSentryUserContext } from '@/shared/utils/sentryContext';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    const userContext = getSentryUserContext();
    Sentry.withScope((scope) => {
      scope.setTag('error_boundary', 'global');
      if (userContext.userId) scope.setTag('user_id', userContext.userId);
      if (userContext.organizationId) scope.setTag('organization_id', userContext.organizationId);
      Sentry.captureException(error, {
        contexts: {
          globalError: {
            digest: error.digest,
            context: 'global_error_boundary',
          },
        },
      });
    });
  }, [error]);

  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-red-600 mb-4">500</h1>
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                Something went wrong
              </h2>
              <p className="text-gray-600 mb-6">
                An unexpected error occurred. We&apos;ve been notified and are working to fix it.
              </p>
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                Reload Page
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}